module.exports = __webpack_public_path__ + "img/bell conditions.6c63fd63.png";